<template>
	<div>
		<!--    搜索部分-->
		<el-form :inline="true" :model="enquiryForm" class="demo-form-inline" label-width="80px">
			<el-form-item label="休眠时间" style="margin-right: 40px;">
				<el-date-picker
					v-model="enquiryForm.last_direct_activate_time"
					type="datetime"
					value-format="yyyy-MM-dd HH:mm:ss"
					clearable
					placeholder="选择日期时间">
				</el-date-picker>
			</el-form-item>
			<el-form-item label="终端类型">
				<el-select v-model="enquiryForm.pos_type" medium clearable placeholder="请选择终端类型">
					<el-option label="杉峰Pro平台" value="10"></el-option>
					<el-option label="河马付" value="20"></el-option>
					<el-option label="手机POS" value="30"></el-option>
				</el-select>
			</el-form-item>
		</el-form>
    <div style="margin-bottom: 10px">
      <el-button size="medium" type="primary" style="font-size: 12px;" @click="handleSearch(enquiryForm)">查询</el-button>
      <el-button size="medium"  style="font-size: 12px;" @click="Reset(enquiryForm)">重置</el-button>
      <el-button size="medium" type="warning" style="font-size: 12px;" @click="exportData">导出</el-button>
      <el-button size="medium"  type="danger" style="font-size: 12px;" @click="printEvent()"> 打印</el-button>
    </div>
<!-- //打印 -->
			<prints ref="prints" :tableData="tableData" :tableTh="tableTh" :tableTd="tableTd" v-show="false"></prints>
		<!--    表格部分-->
		<el-table :data="tableData" style="width: 100%" :default-sort="{prop: 'date', order: 'descending'}"
			v-loading="loading" border id="tableDataId"  size="mini">
			<el-table-column header-align="center" align="center" prop="user_id" label="ID" sortable>
			</el-table-column>
			<el-table-column header-align="center" align="center" prop="pre_org_name" label="机构名称">
			</el-table-column>
			<el-table-column header-align="center" align="center" prop="org_name" label="直属">
			</el-table-column>
			<el-table-column header-align="center" align="center" prop="user_name" label="盟友名称">
			</el-table-column>
			<el-table-column header-align="center" align="center" prop="mobile_phone" label="商户手机号">
			</el-table-column>
			<el-table-column header-align="center" align="center" prop="parent_name" label="推荐人">
			</el-table-column>
			<el-table-column header-align="center" align="center" prop="parent_mobile_phone" label="推荐人手机号">
			</el-table-column>
			<el-table-column header-align="center" align="center" prop="device_code" label="SN号">
			</el-table-column>
			<el-table-column header-align="center" align="center" prop="activate_time" label="激活时间">
			</el-table-column>
			<el-table-column header-align="center" align="center" prop="trade_time" label="最后交易时间">
			</el-table-column>
			<el-table-column header-align="center" align="center" prop="merchant_status_text" label="商户状态">
				<template slot-scope="scope">
				<el-tag v-if="scope.row.merchant_status == '10'" type="warning" disable-transitions>
					{{scope.row.merchant_status_text}}</el-tag>
				<el-tag v-if="scope.row.merchant_status == '20'" type="warning" disable-transitions>
					{{scope.row.merchant_status_text}}</el-tag>
				<el-tag v-if="scope.row.merchant_status == '30'" type="danger" disable-transitions>
					{{scope.row.merchant_status_text}}</el-tag>
				<el-tag v-if="scope.row.merchant_status == '40'"  disable-transitions>
					{{scope.row.merchant_status_text}}</el-tag>
				<el-tag v-if="scope.row.merchant_status == '50'" type="success" disable-transitions>
					{{scope.row.merchant_status_text}}</el-tag>
				<el-tag v-if="scope.row.merchant_status == '60'" type="success" disable-transitions>
					{{scope.row.merchant_status_text}}</el-tag>
				</template>
			</el-table-column>
			<el-table-column header-align="center" align="center" prop="pos_type_name" label="设备类型">
			</el-table-column>
		</el-table>
		<!-- 分页部分 -->
		<el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
			:page-sizes="[20,50,100,200,500,1000]" :page-size="page_size" :total="total"
			layout="total, sizes, prev, pager, next, jumper" style="text-align: right"></el-pagination>

	</div>
</template>

<script>
	import {
		export_json_to_excel
	} from "@/excel/Export2Excel";
	import prints from '@/components/print.vue'
	export default {
		name: "userInformationOne",
		components:{
			prints
		},
		data() {
			return {
				// 主页面部分
				loading: true, //列表loadding
				page_size: 20, //条数
				total: 0, //总数
				tableData: [], //表格数据
				enquiryForm: {
					page_size: 20,
					page: 1,
					last_direct_activate_time:"",
					pos_type:"",
				},
				//打印
				tableTh:null,
				tableTd:null,
			}
		},
		created() {
			this.getData(this.enquiryForm)
			this.tableTh =  ['ID', '机构名称', '运营中心', '代理商名称', '商户手机号', '上级代理商', '上级代理商手机号', 'SN号', '激活时间', '最后交易时间','商户状态'];
			this.tableTd = ['user_id','pre_org_name','org_name', 'user_name', 'mobile_phone', 'parent_name', 'parent_mobile_phone',
				'device_code', 'activate_time', 'trade_time', 'merchant_status_text'];
			this.$nextTick(()=>{
				this.$refs.prints.prints();
			})
		},
		methods: {
			//打印
			printEvent(){
				this.$nextTick(()=>{
					this.$refs.prints.prints();
					this.$refs.prints.print();
				})
			},
			
			// 主页面部分
			//搜索
			handleSearch(searchForm) {
				searchForm.page = 1;
				this.getData(searchForm);
			},
			//重置
			Reset(searchForm) {
				searchForm.page = 1;
				searchForm.user_name = '';
				searchForm.last_direct_activate_time="";
				searchForm.pos_type="";
				this.getData(searchForm);
			},
			//分页
			handleCurrentChange(page) { //当前选中页
				this.enquiryForm.page = page;
				this.getData(this.enquiryForm);
			},
			handleSizeChange(limit) { //条数
				this.enquiryForm.page_size = limit;
				this.enquiryForm.page = 1;
				this.getData(this.enquiryForm);
			},
			//获取数据
			getData(params) { //初始化数据
				this.loading = true;
				this.$api.post("/api/merchant/dormantMerchantList?page=" + params.page, params, res => {
					if (res.status == 200) {
						let tableData = res.data;
						this.total = tableData.total; //总数
						tableData.list.forEach(item => { //实名状态转换文本
							if(item.merchant_status == '10'){
								item.merchant_status_text = '未绑定'
							}else if(item.merchant_status == '20'){
								item.merchant_status_text = '已解绑'
							}else if(item.merchant_status == '30'){
								item.merchant_status_text = '调拨中'
							}else if(item.merchant_status == '40'){
								item.merchant_status_text = '已绑定'
							}else if(item.merchant_status == '50'){
								item.merchant_status_text = '已激活'
							}else if(item.merchant_status == '60'){
								item.merchant_status_text = '已达标'
							}
						});
						this.tableData = tableData.list;
					} else {
						this.$message.error(res.msg);
					}
					//渲染结束后取消加载
					this.loading = false;
				})
			},
			// 导出
			exportData() {
				let th = ['ID', '机构名称', '运营中心', '代理商名称', '商户手机号', '上级代理商', '上级代理商手机号', 'SN号', '激活时间', '最后交易时间','商户状态'];
				let excelData = ['user_id','pre_org_name','org_name', 'user_name', 'mobile_phone', 'parent_name', 'parent_mobile_phone',
					'device_code', 'activate_time', 'trade_time', 'merchant_status_text'];
				let data = this.formatJson(excelData, this.tableData);
				let defaultTitle = '导出文件';
				export_json_to_excel(th, data, defaultTitle)
			},
			formatJson(filterVal, jsonData) {
				return jsonData.map(v => filterVal.map(j => v[j]))
			},
			// 表单部分
			//表单分页
			handleCurrentChange1(page) { //当前选中页
				this.dialogForm.page = page;
				this.getDialogData(this.dialogForm, this.choiceState);
			},
			handleSizeChange1(limit) { //表单条数
				this.dialogForm.page_size = limit;
				this.dialogForm.page = 1;
				this.getDialogData(this.dialogForm, this.choiceState);
			},
		
		}
	}
</script>

<style scoped>
	/deep/ .el-form-item__content .el-input-group {
		vertical-align: middle !important;
	}
	.code {
		cursor: pointer;
	}

	.code:hover {
		color: blue;
		text-decoration: underline;
	}
</style>
